import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, apiErrorMessage, formatDate } from "@/lib/api";

const STATUS_LABELS = { draft: "Чернова", published: "Публикувана", unpublished: "Свалена", scheduled: "Насрочена" };

export default function AdminArticles() {
  const [status, setStatus] = useState("all");
  const [articles, setArticles] = useState([]);

  const load = () => api.get("/articles", { params: { status, limit: 100 } }).then(({ data }) => setArticles(data.items));
  useEffect(() => { load(); }, [status]);

  const setArticleStatus = async (article, newStatus) => {
    try {
      await api.put(`/articles/${article.id}`, { ...article, status: newStatus });
      load();
    } catch (err) {
      toast.error(apiErrorMessage(err));
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Изтриване на статията?")) return;
    await api.delete(`/articles/${id}`);
    load();
  };

  return (
    <div data-testid="admin-articles-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-serif text-3xl font-bold text-[#1A1A1A]">Статии</h1>
        <Link to="/admin/articles/new" className="bg-[#A6192E] hover:bg-[#8C1123] text-white text-sm font-bold uppercase tracking-wide px-5 py-2.5" data-testid="admin-create-article-btn">
          + Нова статия
        </Link>
      </div>
      <Tabs value={status} onValueChange={setStatus} className="mb-6">
        <TabsList>
          <TabsTrigger value="all" data-testid="admin-articles-tab-all">Всички</TabsTrigger>
          <TabsTrigger value="draft" data-testid="admin-articles-tab-draft">Чернови</TabsTrigger>
          <TabsTrigger value="published" data-testid="admin-articles-tab-published">Публикувани</TabsTrigger>
          <TabsTrigger value="unpublished" data-testid="admin-articles-tab-unpublished">Свалени</TabsTrigger>
          <TabsTrigger value="scheduled" data-testid="admin-articles-tab-scheduled">Насрочени</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="bg-white border border-[#E2E8F0]" data-testid="admin-article-table">
        {articles.map((a) => (
          <div key={a.id} className="flex items-center gap-4 px-4 py-3 border-b border-[#E2E8F0] last:border-b-0" data-testid={`admin-article-row-${a.slug}`}>
            <div className="flex-1">
              <Link to={`/admin/articles/${a.id}/edit`} className="font-semibold text-[#1A1A1A] hover:text-[#A6192E]">{a.title}</Link>
              <div className="text-xs text-[#718096] mt-0.5">{a.category_name} &middot; {formatDate(a.published_at) || "—"}</div>
            </div>
            <span className="text-xs font-semibold px-2 py-1 bg-[#F3F4F6]">{STATUS_LABELS[a.status] || a.status}</span>
            {a.status === "published" ? (
              <Button size="sm" variant="outline" onClick={() => setArticleStatus(a, "unpublished")} data-testid={`admin-article-unpublish-${a.slug}`}>Свали</Button>
            ) : (
              <Button size="sm" variant="outline" onClick={() => setArticleStatus(a, "published")} data-testid={`admin-article-publish-${a.slug}`}>Публикувай</Button>
            )}
            <Button size="sm" variant="outline" onClick={() => remove(a.id)} className="text-red-600 border-red-200" data-testid={`admin-article-delete-${a.slug}`}>Изтрий</Button>
          </div>
        ))}
        {articles.length === 0 && <p className="p-4 text-sm text-[#718096]">Няма статии.</p>}
      </div>
    </div>
  );
}
